import type { ProofStrip as Data } from "@/lib/types";

export default function ProofStrip({ data }: { data: Data }) {
  return (
    <section className="proof-strip">
      <div className="proof-inner">
        <div className="proof-label">{data.label}</div>
        <div className="proof-logos">
          {data.logos.map((logo) => (
            <span key={logo} className="proof-logo">
              {logo}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
